<template>
  <section id="services" class="section services">
    <div class="section-container reveal">
      <div class="section-head services-head">
        <div>
          <span class="section-label">Layanan</span>
          <h2 class="section-title">Layanan teknologi untuk bisnis modern</h2>
        </div>
        <a href="#howitworks" class="btn btn-primary">Proses Kami</a>
      </div>

      <p class="section-copy services-copy">
        Mulai perjalanan transformasi digital Anda dengan layanan yang dirancang
        untuk efisiensi operasional, pertumbuhan bisnis, dan pengalaman pengguna
        yang lebih baik.
      </p>

      <div class="services-grid">
        <article v-for="service in services" :key="service.title" class="service-card card">
          <span class="service-icon" aria-hidden="true">
            <ion-icon :name="service.icon"></ion-icon>
          </span>
          <h3>{{ service.title }}</h3>
          <p>{{ service.description }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AppServices",
  data() {
    return {
      services: [
        {
          icon: "settings-outline",
          title: "Sistem Bisnis Digital",
          description:
            "E-commerce, POS, HR, dan membership system yang terintegrasi agar proses bisnis lebih cepat dan akurat.",
        },
        {
          icon: "grid-outline",
          title: "Pengembangan Aplikasi",
          description:
            "Pengembangan website, aplikasi mobile, dan desktop yang disesuaikan dengan kebutuhan operasional Anda.",
        },
        {
          icon: "analytics-outline",
          title: "Konsultasi & Analisis TI",
          description:
            "Analisis kebutuhan sistem untuk menyusun solusi teknologi yang tepat, aman, dan efisien.",
        },
        {
          icon: "rocket-outline",
          title: "Program Magang",
          description:
            "Program magang berbasis proyek nyata bagi pelajar dan mahasiswa untuk masuk ke dunia kerja teknologi.",
        },
        {
          icon: "school-outline",
          title: "Program Edukasi",
          description:
            "Bootcamp, workshop, dan mentoring untuk meningkatkan kapabilitas digital secara terstruktur.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.services {
  padding-top: 28px;
}

.services-head {
  margin-bottom: 18px;
}

.services-copy {
  margin-bottom: 28px;
}

.services-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.service-card {
  flex: 0 1 calc((100% - 32px) / 3);
  min-width: 0;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.72);
  background: linear-gradient(160deg, #fff 55%, #f3f7ff);
  transition: transform 0.24s ease, box-shadow 0.24s ease;
}

.service-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-soft);
}

.service-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  background: linear-gradient(135deg, var(--primary), #1c63c3);
  color: #fff;
}

.service-icon ion-icon {
  font-size: 1.42rem;
}

.service-card h3 {
  font-size: 1.13rem;
  line-height: 1.35;
  color: var(--text);
}

.service-card p {
  margin-top: 10px;
  font-size: 0.96rem;
}

@media (max-width: 980px) {
  .service-card {
    flex-basis: calc((100% - 32px) / 3);
  }
}

@media (max-width: 760px) {
  .services-grid {
    gap: 10px;
  }

  .service-card {
    flex-basis: calc((100% - 20px) / 3);
    padding: 10px 8px;
    border-radius: 12px;
  }

  .service-icon {
    width: 34px;
    height: 34px;
    margin-bottom: 8px;
    border-radius: 10px;
  }

  .service-icon ion-icon {
    font-size: 0.95rem;
  }

  .service-card h3 {
    font-size: 0.7rem;
    line-height: 1.3;
  }

  .service-card p {
    margin-top: 6px;
    font-size: 0.58rem;
    line-height: 1.4;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .services-head .btn {
    width: 100%;
  }
}

@media (max-width: 420px) {
  .service-card {
    flex-basis: calc((100% - 10px) / 2);
  }

  .service-card h3 {
    font-size: 0.78rem;
  }

  .service-card p {
    font-size: 0.66rem;
  }
}
</style>
